import InternalCollapse from './collapse';
import Panel from './panel';
var Collapse = InternalCollapse;
Collapse.Panel = Panel;
export { Panel };
export default Collapse;